var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',[_c('section',{staticClass:"account_wraper"},[_c('div',{staticClass:"container_large"},[_c('div',{staticClass:"login_holder"},[_c('button',{staticClass:"button",on:{"click":_vm.logInWithFacebook}},[_vm._v("\n            Login with Facebook\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3a6cc6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/facebook.vue
// module id = 404
// module chunks = 0